/*import data from "./data/2.13.json";
const lll = "2.13"*/


//***********************************************
//
// Management of the username
//
//***********************************************

export function getUsername() {
    return localStorage.getItem('currentUsername') || null;
}


function localStorageGetItem(item) {
    return localStorage.getItem(item);
}

function localStorageSetItem(item, value) {
    localStorage.setItem(item, value)
}

export function localStorageRemoveItem(item) {
    localStorage.removeItem(item)
}


//***********************************************************
//
//
//
//***********************************************************


const encoder = new TextEncoder();

const pickIndex = (probas) => {
    var pick = Math.random();
    let index = 0;
    for (const p of probas) {
        pick -= p;
        if (pick <= 0) {
            return index;
        }
        index += 1;
    }
}


/*function GetChatGPTPrompt(lesson) {
      const allLessons = new Set();
      Object.values(params).forEach(word => { // FOIREDINGUE ???
        if (word.cat) {
            word.cat.forEach(category => (category.substring(0,1)==='1' ? allLessons.add(category) :  null))
        }
      });
      const allSortedLessons = [...allLessons].sort();
      const index = allSortedLessons.indexOf(lesson);
      if (index === -1) {
        return "";
      }
      const group1Lessons =  allSortedLessons.slice(0, index);
      const group2Lessons =  allSortedLessons.slice(index, index+1);
      const group1Words =  GetPossibleWords(group1Lessons,[],[]);
      const group2Words =  GetPossibleWords(group2Lessons,[],[]);

      let prompt = "";

      for (let j=0; j<2; j++) {
          let group = (j === 0 ? group1Words : group2Words);
          prompt = prompt + "\nJe considère le groupe " + (j + 1).toString() + " de mots suivants : \n";
          let ty = ["adj.", "nom c.", "verbe", "pronom", "expression", "autre"];
          for (let i = 0; i < ty.length; i++) {
              let w = group.filter(w => w.cat.includes(ty[i]));
              let type1 = (ty[i] === "nom c." ? "nom commun" : (ty[i]==="adj." ? "adjectif" : ty[i]));
              if (w.length !== 0) {
                  prompt = prompt + "- " + type1 + " : " + w.reduce((a, b) => a + "," + Word2Str(b), "");
                  prompt = prompt + "\n"
              }
          }
      }

      prompt = prompt + "\nPropose moi 30 phrases en hébreu qui doivent vérifier les contraintes suivantes : \n";
      prompt = prompt + "- Chaque phrase ne doit utiliser que des mots du groupe 1 ou du groupe 2\n";
      prompt = prompt + "- Dans chaque phrase il doit y avoir au moins un mot du groupe 2 \n\n";
      prompt = prompt + "Chaque phrase doit être représentée par un objet json :  \n" +
          "- clé \"formes\" avec un tableau de 4 éléments : \n" +
          "* la phrase en hébreu\n" +
          "* la phrase en phonétique\n" +
          "* la phrase en français  \n" +
          "* la phrase en hébreu avec les voyelles \n" +
          "- clé \"cat\" = ["+lesson+"] \n";

    return prompt
}*/


// Managing voice
let cachedVoice = null;
const checkSelectedVoice = () => {
    if (!cachedVoice) {
        const voiceName = localStorageGetItem('audioVoice');
        if (!voiceName) {
            return null
        }
        const allVoices = speechSynthesis.getVoices();
        cachedVoice = allVoices.filter((v) => v.name === voiceName)[0]
    }
    return cachedVoice
}


// text : either a single sentence or a list
// onSwitchText : if text is a list of texts, this is a callback called when the reading is switching text
// pauseDuration : pause after an end of sentence is met
const ReadHebrewText = (text, onEnd = null, onSwitchText = null, pauseDuration = 300) => {

    if ('speechSynthesis' in window) {

        let flagAdvancedReading =  localStorage.getItem("advancedProsody") === "1";

        // Build the textsList
        let textsList = text;
        if (!Array.isArray(text))
            textsList = [text]

        // Loop on the texts until a text with an end of sentence punctuation is found
        let textsList1 = []
        while (textsList.length !== 0) {
            textsList1.push(textsList.shift().replace(/\[.*?\]/g, "").trim(" "))
            const text = textsList1[textsList1.length - 1]
            const char = text[text.length - 1]
            if (char === '.' || char === '!' || char === '?') break
        }

        const onEndReadingTextList1 = () => {
            if (textsList.length === 0) {
                if (onEnd !== null) onEnd()
            }
            else {
                console.log("TTTTT",textsList)
                // we reached an end of sentence ==> pause before reading the next one
                setTimeout(
                    () => {ReadHebrewText(textsList, onEnd, onSwitchText)},
                    pauseDuration
                );
            }
        }

        // Then read the textList1
        if (onSwitchText!==null)
            onSwitchText();
        ReadHebrewTextsListWithoutPause(textsList1, onEndReadingTextList1, onSwitchText, flagAdvancedReading);
    }
};


const ReadHebrewTextsListWithoutPause = (textsList, onEnd, onSwitchText = null, flagAdvancedReading = false) => {

    if (textsList.length === 0) {
        onEnd();
        return;
    }

    // Set utterance
    let utterance = new SpeechSynthesisUtterance();
    utterance.voice = checkSelectedVoice(); // Langue hébreu
    speechSynthesis.cancel(); // cancel reading if any

    // Manage advanced reading
    if (flagAdvancedReading) {

        // Build whole text with corresponding indices for each text (used for advanced reading only)
        let wholeText = ""
        let textIndices = []
        for (let text of textsList) {
            wholeText += " " + text
            textIndices.push(wholeText.length)
        }
        utterance.text = wholeText;
        utterance.onend = onEnd;

        utterance.onboundary = (e) => {
            if (textIndices.length !== 1 && Math.abs(e.charIndex - textIndices[0]) <= 1) {
                textIndices.shift()
                onSwitchText();
            }
        }
    }

    // Regular mode
    else {
        const onEndTextReading = () => {
            if (onSwitchText !== null) onSwitchText()
            ReadHebrewTextsListWithoutPause(textsList, onEnd, onSwitchText, flagAdvancedReading)
        }
        if (textsList.length === 1)
            utterance.onend = onEnd;
        else
            utterance.onend = onEndTextReading;
        utterance.text = textsList.shift()
    }

    utterance.rate = localStorage.getItem("speechSpeed") ? localStorage.getItem("speechSpeed") : 1;

    // Then we read the text !
    console.log("READING", utterance.text)
    speechSynthesis.speak(utterance);
};


export const isSpeechPossible = () => {
//    console.log("SPeech possible", checkSelectedVoice())
    return checkSelectedVoice()
}


// Get the words to be added in french and hebrew
const TextForm2FlatText = (word, hebrewForm) => {
    if (word.type !== "words") return word.formes[hebrewForm];
    if ("article" in word && word.article === false) return word.formes[hebrewForm];

    let [hebrew, phonetic, french, vowels] = word.formes[hebrewForm];

    // Case of a name
    if (word.cat.includes("nom c.")) {
        const frenchForm = (word.genre
            ? (word.genre === "fp" || word.genre === "mp"
                ? word.genre
                : word.genre.substring(0, 1) + hebrewForm.substring(1, 2))
            : hebrewForm)
        const articles = {ms: "un ", fs: "une ", mp: "des ", fp: "des "};
        french = articles[frenchForm] + french;
    }

    // Case of a verb
    else if (word.cat.includes("verbe")) {
        const hebrewPronouns = {
            ms: "הוא", fs: "היא", mp: "הם", fp: "הן",
            x1s: "אני", x2ms : "אתה" , x2fs: "את", x3ms: "הוא", x3fs: "היא",
            x1p: "אנחנו", x2mp: "אתם", x2fp: "אתן", x3mp: "הם", x3fp: "הן"
        };
        const hebrewPronounsWithVowels = {
            ms: "הוּא", fs: "הִיא", mp: "הֵם", fp: "הֵן",
            x1s: "אֲנִי", x2ms : "אַתָּה" , x2fs: "אַתְּ", x3ms: "הוּא", x3fs: "הִיא",
            x1p: "אֲנַחְנוּ", x2mp: "אַתֶּם", x2fp: "אַתֶּן", x3mp: "הֵם", x3fp: "הֵן"
        };
        const hebrewPhonetic = {
            ms: "hou", fs: "hi", mp: "hem", fp: "hen",
            x1s: "ani", x2ms : "ata" , x2fs: "at", x3ms: "hou", x3fs: "hi",
            x1p: "anakhnu", x2mp: "atem", x2fp: "aten", x3mp: "hem", x3fp: "hen"
        };
        const frenchPronouns = {
            ms: "il", fs: "elle", mp: "ils", fp: "elles",
            x1s: "je",  x2ms : "tu" , x2fs: "tu (f)", x3ms: "il", x3fs: "elle",
            x1p: "nous", x2mp: "vous", x2fp: "vous (f)", x3mp: "ils", x3fp: "elles"
        };
        if (hebrewForm !== 'inf') {
            let hebrewForm1 = hebrewForm.substring(0,1)==='p' ? 'x'+hebrewForm.substring(1) : hebrewForm
            if (hebrewForm1==="x1s" && /^[aeiou]/.test(french))
                french = "j'" + french;
            else
                french = frenchPronouns[hebrewForm1] + " " + french;
            hebrew = hebrewPronouns[hebrewForm1] + " " + hebrew;
            phonetic = hebrewPhonetic[hebrewForm1] + " " + phonetic;
            vowels = hebrewPronounsWithVowels[hebrewForm1] + " " + vowels;
        }
    }

    return [hebrew, phonetic, french, vowels]
};


// Get nature and gender of the hebrew word corresponding to word.formes[hebrewForm]
const getHebrewTextInfo = (word, hebrewForm) => {
    let cat = (word.cat
        ? word.cat.filter(c => ["verbe", "nom c.", "adj.", "prép.", "pronom", "nombre", "nom p."].includes(c))
        : [])
    const nature = (cat.length === 0 ? "" : cat[0])
    let gender =
        (["m", "f", "inf"].includes(hebrewForm)
            ? hebrewForm
            : (["ms", "mp", "fs", "fp"].includes(hebrewForm)
                ? hebrewForm.slice(0, 1)
                : ""))
    gender = (gender === 'm' ? 'masc.' : (gender === "f" ? "fém." : gender))
    return (nature === "" ? gender : (gender === "" ? nature : nature + ", " + gender))
};

/*
const transform1 = (obj) => {
const cleaned = {
vocabulary: [],
sentences: []
};

const vocabList = Object.values(obj.vocabulary || []);
for (const entry of vocabList) {
const newEntry = { ...entry };

// Inline "cat"
if (Array.isArray(newEntry.cat)) {
  newEntry.cat = { __inline__: newEntry.cat };
}

// Inline "formes"
if (newEntry.formes && typeof newEntry.formes === "object") {
  for (const cle in newEntry.formes) {
    if (Array.isArray(newEntry.formes[cle])) {
      newEntry.formes[cle] = { __inline__: newEntry.formes[cle] };
    }
  }
}

cleaned.vocabulary.push(newEntry);
}

if (Array.isArray(obj.sentences)) {
cleaned.sentences = obj.sentences.map(s => ({ __inline__: s.formes }));
}

const placeholderMap = new Map();
let counter = 0;

// Custom replacer to inject placeholder tokens
const json = JSON.stringify(cleaned, (key, value) => {
if (value && typeof value === 'object' && value.__inline__) {
  const token = `__INLINE_PLACEHOLDER_${counter++}__`;
  placeholderMap.set(token, JSON.stringify(value.__inline__));
  return token;
}
return value;
}, 2);

// Replace tokens with real inline content (no quotes)
let final = json;
for (const [token, actual] of placeholderMap.entries()) {
final = final.replace(`"${token}"`, actual);
}

// Optionnel : retirer tous les "/"
final = final.replaceAll("/", "").replaceAll(",\""+lll+"\"","");

return final;

}
const transform = () => {

    const jsonString = transform1(data)

// 2. Créer un blob
const blob = new Blob([jsonString], { type: "application/json" });

// 3. Créer un lien de téléchargement temporaire
const url = URL.createObjectURL(blob);
const lien = document.createElement("a");
lien.href = url;
lien.download = lll+".json";

// 4. Cliquer automatiquement sur le lien
lien.click();

// 5. Nettoyer l'URL
URL.revokeObjectURL(url);
}
*/

export const isRecordingPossible = () => {
    return (checkSelectedVoice() && ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window))
}

export const initRecognition = ({onResult, onStart, onEnd}) => {
    if (!isRecordingPossible()) return;
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    console.log("VOICE RECORD init 1", SpeechRecognition)
    const recognition = new SpeechRecognition();
    recognition.lang = checkSelectedVoice().lang;
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    console.log("VOICE RECORD init 2", recognition)

    recognition.onresult = (event) => {
        console.log("VOICE RECORD onResult ", event)
        const transcript = event.results[0][0].transcript;
        onResult(transcript);
    };

    recognition.onstart = onStart;
    recognition.onend = onEnd;

    return recognition;
};

let recognition = null;
export const startRecording = ({onResult, onStart, onEnd}) => {
    recognition = initRecognition(
        {
            onResult: onResult,
            onStart: onStart,
            onEnd: onEnd
        });
    if (!recognition) return;
    console.log("VOICE RECORD startRecording ")

    recognition.start();
}

export const stopRecording = () => {
    if (recognition) {
        console.log("VOICE RECORD stopRecording ")
        recognition.stop();
    }
}

export const getNumIcon = (num) => {
    if (num <= 0) return "";
    if (num >= 100) num = 99;
    const str09 = "0️⃣1️⃣2️⃣3️⃣4️⃣5️⃣6️⃣7️⃣8️⃣9️⃣"
    const unit = num % 10;
    const tens = (num - num % 10) / 10
    return tens === 0 ? str09.slice(3 * (unit), 3 * (unit + 1)) : str09.slice(3 * (tens), 3 * (tens + 1)) + str09.slice(3 * (unit), 3 * (unit + 1))
}

const getSpeech2Text = () => {
    return localStorage.getItem("speech2Text") || "webapi";
}

const getRepeatFactor = () => {
    return JSON.parse(localStorage.getItem("repeatFactor") || "1");
}

const getBookName = () => {
    if (localStorageGetItem("bookName") === null)
        localStorageSetItem("bookName","A")
    return localStorageGetItem("bookName")
}


export {
    localStorageSetItem,
    localStorageGetItem,
    getHebrewTextInfo,
    pickIndex,
    ReadHebrewText,
    TextForm2FlatText,
    getSpeech2Text,
    getRepeatFactor,
    getBookName
};
